import { render } from "./AdminPlatformContractsHome.vue?vue&type=template&id=ca570860&scoped=true"
import script from "./AdminPlatformContractsHome.vue?vue&type=script&lang=js"
export * from "./AdminPlatformContractsHome.vue?vue&type=script&lang=js"

import "./AdminPlatformContractsHome.vue?vue&type=style&index=0&id=ca570860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca570860"]])

export default __exports__